// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__QpAw9"};